import React from 'react';
import { FilterMenu, IFilterMenuProps } from 'src/pages/CatalogPage/components/FilterMenu/FilterMenu';
import { FiltersMobileMenu } from 'src/pages/CatalogPage/components/FilterMenu/FiltersMobileMenu/FiltersMobileMenu';
import { useWindowSize } from 'src/lib/useWindowSize';
import { screenWidths } from '@riac/design-system';

interface IFilterDisplayControl extends IFilterMenuProps {
  size: 'small' | 'large';
}

export const FilterDisplayControl = ({ size, ...props }: IFilterDisplayControl) => {
  const { width } = useWindowSize();

  if(width && width < screenWidths.desktop) {
    return size === 'small' ? <FiltersMobileMenu {...props} /> : null;
  } else if(size === 'large') {
    return <FilterMenu {...props} />;
  }
  return null;
};

